export default __webpack_public_path__ + "static/media/close-gray.d6413e55.svg";